var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedPaymentMethod.includes("pix")
    ? _c("div", [
        _c(
          "div",
          { staticClass: "emd-container", attrs: { "data-testid": "div" } },
          [
            _c(
              "div",
              { staticClass: "emd-container__header eu-py_4_md eu-px_5_md" },
              [
                _c(
                  "h2",
                  { staticClass: "emd-text _size_section _color_default" },
                  [_vm._v(" " + _vm._s(_vm.$t("pix.payment.title")) + " ")]
                ),
              ]
            ),
            _c("hr", { staticClass: "emd-divider" }),
            _c(
              "div",
              { staticClass: "emd-container__content eu-pa_5_md" },
              [
                _vm.tabbarError.status
                  ? _c("emd-alert", {
                      attrs: {
                        variant: "danger",
                        title: _vm.$t("tabbarError"),
                        autoclose: "",
                      },
                      on: {
                        cancel: function ($event) {
                          _vm.tabbarError.status = false
                        },
                      },
                    })
                  : _vm._e(),
                _c("form", { attrs: { action: "" } }, [
                  _c("div", { staticClass: "eu-flex eu-column eu-row_md" }, [
                    _c("div", { staticClass: "eu-flex-item eu-basis_4_md" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c("label", { staticClass: "emd-label _required" }, [
                          _vm._v(_vm._s(_vm.$t("pix.payment.dueDate"))),
                        ]),
                        _c("div", { staticClass: "emd-input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "##/##/####",
                                expression: "'##/##/####'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pix.expires_at,
                                expression: "pix.expires_at",
                              },
                            ],
                            staticClass: "emd-input",
                            class: {
                              _state_error:
                                !_vm.isValidDueDate && _vm.showFeedbacks.status,
                            },
                            attrs: {
                              type: "text",
                              placeholder: "dd/mm/aaaa",
                              "data-testid": "input",
                            },
                            domProps: { value: _vm.pix.expires_at },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.pix,
                                  "expires_at",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        !_vm.isValidDueDate &&
                        _vm.showFeedbacks.status &&
                        !_vm.pix.expires_at.length
                          ? _c(
                              "p",
                              {
                                staticClass: "emd-input-feedback _state_error",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("pix.payment.errors.required"))
                                ),
                              ]
                            )
                          : _vm._e(),
                        !_vm.isValidDueDate &&
                        _vm.showFeedbacks.status &&
                        _vm.pix.expires_at.length
                          ? _c(
                              "p",
                              {
                                staticClass: "emd-input-feedback _state_error",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("pix.payment.errors.dueDate", {
                                      date: _vm.setDatePlaceHolder,
                                    })
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ]
        ),
        _c("div", { staticClass: "el-section" }, [
          _c(
            "div",
            {
              staticClass:
                "eu-display_flex eu-justify_space-between eu-wrap_reverse",
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "emd-btn _color_secondary _type_text _block_mobile",
                  on: { click: _vm.reverseRoute },
                },
                [
                  _c("i", { staticClass: "uil uil-angle-left" }),
                  _vm._v(" " + _vm._s(_vm.$t("pix.payment.back")) + " "),
                ]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "emd-btn _color_secondary _block_mobile eu-mb_5 eu-no-margin_sm",
                  on: { click: _vm.nextRoute },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("pix.payment.next")) + " "),
                  _c("i", { staticClass: "uil uil-angle-right" }),
                ]
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }